export default "__VITE_ASSET__Di5R_K46__"